module.exports = __webpack_public_path__ + "static/elephant-4-0d15e32cef7b13649b6f28def161c00a.jpg";